import React from 'react';
import { Link } from 'react-router-dom';

const JobOpportunities = () => {
  return (
    <div className="pt-16 px-4 min-h-screen bg-background text-light">
      <div className="max-w-4xl mx-auto py-12">
        <h1 className="text-4xl font-bold text-primary mb-8">Job Opportunities</h1>
        
        {/* Introduction */}
        <section className="mb-12">
          <div className="bg-light-gray p-6 rounded-lg shadow-lg">
            <p className="text-xl text-secondary mb-4">
              Thank you for your interest in joining the Rueda de la Vida Dance Society team!
            </p>
            <p className="text-secondary">
              Currently, we do not have any job openings. Please check back later for future opportunities.
            </p>
          </div>
        </section>

        {/* About Us Section */}
        <section>
          <h2 className="text-2xl font-bold text-primary mb-6">About Rueda de la Vida Dance Society</h2>
          <div className="bg-light-gray p-6 rounded-lg shadow-lg">
            <p className="text-secondary mb-4">
              Rueda de la Vida Dance Society's mission is to enrich British Columbia's vibrant arts and culture landscape by fostering a deep appreciation for AfroLatin dance and its cultural heritage.
            </p>
            <p className="text-secondary mb-4">
              Our team is passionate about creating inclusive, welcoming spaces where everyone can experience the transformative power of dance.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default JobOpportunities;
